export const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api'
export const CSRF_URL =
  process.env.REACT_APP_BACKEND_URL + '/sanctum/csrf-cookie'
